import { render, staticRenderFns } from "./MdVideoPlayer.vue?vue&type=template&id=4054a716&scoped=true&"
import script from "./MdVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./MdVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MdVideoPlayer.vue?vue&type=style&index=0&id=4054a716&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4054a716",
  null
  
)

export default component.exports